import {Injectable} from '@angular/core';
import {WebViewerOptions} from '@pdftron/webviewer';
import {BehaviorSubject, firstValueFrom} from 'rxjs';
import {API} from '../../shared/constants/api.constants';
import {ErrorHandlingHttpClient} from '../../shared/services/error-handling-http-client.service';
import {map} from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PdftronKeyService {
  private licenseKeySubject = new BehaviorSubject<string | null>(null);
  licenseKey$ = this.licenseKeySubject.asObservable();
  private licenseKey: string | null = null;
  private licenseKeyPromise: Promise<string> | null = null;
  constructor(private errorHandlingHttpClient: ErrorHandlingHttpClient) {}

  loadPdfLicense(): Promise<string> {
    if (this.licenseKey) {
      return Promise.resolve(this.licenseKey);
    }
    if (this.licenseKeyPromise) {
      return this.licenseKeyPromise;
    }
    this.licenseKeyPromise = firstValueFrom(
      this.errorHandlingHttpClient.get(API.getPDFTronKey()).pipe(
        map((data: { key: string }) => data.key)
      )
    ).then(encodedKey => {
      const decodedKey = atob(encodedKey);
      this.licenseKey = decodedKey;
      this.licenseKeySubject.next(decodedKey);
      return decodedKey;
    })
      .finally(() => { this.licenseKeyPromise = null; });
    return this.licenseKeyPromise;
  }

  getLicenseKey(): string | null {
    return this.licenseKey;
  }

  clearLicenseKey(): void {
    this.licenseKey = null;
    this.licenseKeySubject.next(null);
    this.licenseKeyPromise = null;
  }
}

// Default WebViewer configuration
export function createPdfConfig(licenseKey: string): WebViewerOptions {
  return {
    path: '../webviewer',
    fullAPI: true,
    licenseKey,
    enableAzureWorkaround: true,
    enableAnnotations: false,
    disabledElements: [
      'toolbarGroup-Edit',
      'toolbarGroup-Annotate',
      'toolbarGroup-Shapes',
      'toolbarGroup-Insert',
      'toggleNotesButton'
    ]
  };
}
